document.addEventListener('DOMContentLoaded', function () {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const AVAILABILITY_VALUE = '1';

  function isCollectionPath(pathname) {
    return pathname.startsWith('/collections/');
  }

  function isCollectionPage() {
    return isCollectionPath(window.location.pathname);
  }

  function addAvailabilityToUrl(rawUrl) {
    let url;

    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (!isCollectionPath(url.pathname)) return null;

    url.searchParams.set(AVAILABILITY_PARAM, AVAILABILITY_VALUE);
    return url;
  }

  function ensureAvailabilityInCurrentUrlWithoutReload() {
    if (!isCollectionPage()) return;

    const url = new URL(window.location.href);

    if (url.searchParams.get(AVAILABILITY_PARAM) !== AVAILABILITY_VALUE) {
      url.searchParams.set(AVAILABILITY_PARAM, AVAILABILITY_VALUE);
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }

  function ensureAvailabilityInFacetForms() {
    if (!isCollectionPage()) return;

    document.querySelectorAll('form').forEach(function (form) {
      const action = form.getAttribute('action') || '';

      if (
        action &&
        !action.startsWith('/collections') &&
        !action.includes(window.location.pathname)
      ) {
        return;
      }

      let input = form.querySelector(
        'input[name="' + AVAILABILITY_PARAM + '"]'
      );

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = AVAILABILITY_PARAM;
        form.appendChild(input);
      }

      input.value = AVAILABILITY_VALUE;
    });
  }

  function ensureAvailabilityInCurrentCollectionUrls(root) {
    if (!isCollectionPage()) return;

    root.querySelectorAll('a[href]').forEach(function (link) {
      const rawHref = link.getAttribute('href');

      if (!rawHref || rawHref.startsWith('#')) return;

      let url;

      try {
        url = new URL(rawHref, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname !== window.location.pathname) return;

      if (url.searchParams.get(AVAILABILITY_PARAM) !== AVAILABILITY_VALUE) {
        url.searchParams.set(AVAILABILITY_PARAM, AVAILABILITY_VALUE);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    });
  }

  function maintainAvailability() {
    ensureAvailabilityInFacetForms();
    ensureAvailabilityInCurrentCollectionUrls(document);
  }

  /*
   * Si alguien entra directamente a una colección sin el parámetro,
   * actualizamos la URL sin recargar la página. Así eliminamos el
   * segundo refresh visible que provocaba window.location.replace().
   */
  ensureAvailabilityInCurrentUrlWithoutReload();
  maintainAvailability();

  /*
   * Be Yours puede volver a renderizar filtros mediante JavaScript.
   * Volvemos a proteger los formularios y enlaces de la colección actual.
   */
  const observer = new MutationObserver(function () {
    maintainAvailability();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !isCollectionPage()) return;

    ensureAvailabilityInFacetForms();
  });

  /*
   * Cuando el usuario navega a OTRA colección desde cualquier enlace
   * interno (menú, banner, etc.), añadimos availability=1 ANTES de la
   * navegación. La colección llega ya con el filtro y no necesita
   * recargarse una segunda vez.
   */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link) return;

    const target = link.getAttribute('target');
    if (target && target !== '_self') return;
    if (link.hasAttribute('download')) return;

    const rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return;

    const url = addAvailabilityToUrl(rawHref);
    if (!url) return;

    if (url.searchParams.get(AVAILABILITY_PARAM) !== AVAILABILITY_VALUE) return;

    const current = new URL(window.location.href);

    if (
      current.pathname === url.pathname &&
      current.search === url.search &&
      current.hash === url.hash
    ) {
      return;
    }

    event.preventDefault();
    window.location.assign(url.toString());
  });
});
